import { useTranslation } from "react-i18next";
import { UserRole } from "components/Reports/reportAssets/assets";
import { useReports } from "hooks/useReports";
import { TypeEnum, filterOption } from "models/filterOption";
import { useMemo } from "react";
import { specialties } from "pages/ControlCenter/UsersPermissionsManagement/UsersPermissionsManagementComponents/controllers/controllerTypes";
import { verifyStatuses } from "pages/ControlCenter/UsersPermissionsManagement/UsersPermissionsManagementComponents/volunteers/volunteerTypes";
import useFilterOptionsUtils from "../filterOptionsUtils";

export const GetFilterOptions = () => {
  const { t } = useTranslation();
  const { enumOptions } = useFilterOptionsUtils();

  const {
    rejectionReasons,
    reportsViolationsTypes,
    tags,
    seriousOffenseReasonsType,
  } = useReports();

  const filterOptionsReport: filterOption = useMemo(
    () => ({
      id: undefined,
      name: "",
      options: [
        {
          field: "reportDate",
          isSelected: false,
          type: TypeEnum.Date,
          value: null,
          label: t("reportDate"),
          options: undefined,
          id: 1,
        },
        {
          field: "updateDate",
          isSelected: false,
          type: TypeEnum.Date,
          value: null,
          label: t("updateDate"),
          options: undefined,
          id: 2,
        },
        {
          field: "offenceIsSeriousCode",
          isSelected: false,
          type: TypeEnum.Enum,
          value: null,
          label: t("offenceIsSeriousCode"),
          options: enumOptions(seriousOffenseReasonsType),
          id: 3,
        },
        {
          field: "offenceTypeCode",
          isSelected: false,
          type: TypeEnum.Enum,
          value: null,
          label: t("offenceType"),
          options: enumOptions(reportsViolationsTypes),
          id: 4,
        },
        {
          field: "rejectionReasonCode",
          isSelected: false,
          type: TypeEnum.Enum,
          value: null,
          label: t("rejectionReasonCode"),
          options: enumOptions(rejectionReasons),
          id: 5,
        },
        {
          field: "tags",
          isSelected: false,
          type: TypeEnum.Enum,
          value: null,
          label: t("tags"),
          options: enumOptions(tags?.tagList),
          id: 6,
        },
        {
          field: "modelType",
          isSelected: false,
          type: TypeEnum.String,
          value: null,
          label: t("modelType"),
          options: undefined,
          id: 7,
        },
        {
          field: "licensePlateNumber",
          isSelected: false,
          type: TypeEnum.String,
          value: null,
          label: t("licenseNumber"),
          options: undefined,
          id: 8,
        },
        {
          field: "carColor",
          isSelected: false,
          type: TypeEnum.String,
          value: null,
          label: t("carColor"),
          options: null,
          id: 9,
        },
        {
          field: "lableLocation",
          isSelected: false,
          type: TypeEnum.String,
          value: null,
          label: t("labelLocation"),
          options: null,
          id: 10,
        },
        {
          type: TypeEnum.String,
          isSelected: false,
          field: "seniorController",
          value: null,
          label: t("seniorController"),
          options: null,
          id: 11,
        },
        {
          type: TypeEnum.String,
          isSelected: false,
          field: "regularController",
          value: null,
          label: t("regularController"),
          options: null,
          id: 12,
        },
        {
          type: TypeEnum.String,
          isSelected: false,
          field: "userAppName",
          value: null,
          label: t("userAppName"),
          options: null,
          id: 13,
        },
        {
          type: TypeEnum.Boolean,
          isSelected: false,
          field: "reportForImmediateTreatment",
          value: true,
          label: t("reportForImmediateTreatment"),
          options: null,
          id: 14,
        },
        {
          type: TypeEnum.Boolean,
          isSelected: false,
          field: "recommendForInformationalMaterial",
          value: true,
          label: t("recommendForInformationalMaterial"),
          options: null,
          id: 15,
        },
        {
          field: "usersCharacteristic",
          isSelected: false,
          type: TypeEnum.String,
          value: null,
          label: t("usersCharacteristic"),
          options: undefined,
          id: 16,
        },
      ],
    }),
    [
      t,
      enumOptions,
      rejectionReasons,
      reportsViolationsTypes,
      tags?.tagList,
      seriousOffenseReasonsType,
    ]
  );

  const filterOptionsVolunteer: filterOption = useMemo(
    () => ({
      id: undefined,
      name: "",
      options: [
        {
          field: "registrationDate",
          isSelected: false,
          type: TypeEnum.Date,
          value: null,
          label: t("registrationDate"),
          options: undefined,
          id: 1,
        },
        {
          field: "lastReportUpdate",
          isSelected: false,
          type: TypeEnum.Date,
          value: null,
          label: t("lastReportUpdate"),
          options: undefined,
          id: 2,
        },
        {
          field: "isVerify",
          isSelected: false,
          type: TypeEnum.Enum,
          value: null,
          label: t("isVerify"),
          options: verifyStatuses,
          id: 3,
        },
        {
          field: "operationSystem",
          isSelected: false,
          type: TypeEnum.String,
          value: null,
          label: t("operationSystem"),
          options: [
            { label: "ios", value: "1" },
            { label: "andriod", value: "2" },
          ],
          id: 4,
        },
        {
          field: "currentVersion",
          isSelected: false,
          type: TypeEnum.String,
          value: null,
          label: t("currentVersion"),
          options: undefined,
          id: 5,
        },
        {
          field: "fullName",
          isSelected: false,
          type: TypeEnum.String,
          value: null,
          label: t("fullName"),
          options: undefined,
          id: 6,
        },
        {
          field: "tz",
          isSelected: false,
          type: TypeEnum.String,
          value: null,
          label: t("tz"),
          options: undefined,
          id: 7,
        },
        {
          field: "characteristic",
          isSelected: false,
          type: TypeEnum.String,
          value: null,
          label: t("usersCharacteristic"),
          options: undefined,
          id: 8,
        },
      ],
    }),
    [t]
  );

  const filterOptionsController: filterOption = useMemo(
    () => ({
      id: undefined,
      filterName: "",
      options: [
        {
          field: "registrationDate",
          isSelected: false,
          type: TypeEnum.Date,
          value: null,
          label: t("registrationDate"),
          options: undefined,
          id: 1,
        },
        {
          field: "lastReportUpdate",
          isSelected: false,
          type: TypeEnum.Date,
          value: null,
          label: t("lastReportUpdate"),
          options: undefined,
          id: 2,
        },
        {
          field: "fullName",
          isSelected: false,
          type: TypeEnum.String,
          value: null,
          label: t("fullNameOfController"),
          options: undefined,
          id: 3,
        },
        {
          field: "userRole",
          isSelected: false,
          type: TypeEnum.Enum,
          value: null,
          label: t("userType"),
          options: [
            { label: t("REGULAR"), value: UserRole.REGULAR },
            { label: t("SENIOR"), value: UserRole.SENIOR },
            {
              label: t("CONTROLCENTER"),
              value: UserRole.CONTROLCENTER,
            },
          ],
          id: 4,
        },
        {
          field: "specialization",
          isSelected: false,
          type: TypeEnum.Enum,
          value: null,
          label: t("specialization"),
          options: specialties,
          id: 5,
        },
      ],
    }),
    [t]
  );

  return {
    filterOptionsReport,
    filterOptionsVolunteer,
    filterOptionsController,
  };
};
